var $ = window.$ = require('jquery');
window.jQuery = window.$;
require('jquery-validation');
//require('jquery-countdown');


var phoneIsValid = require('./phone-validator');
$.validator.addMethod("usPhone", function (value, element) {
    return phoneIsValid(value);
}, "Please enter only digits, dash and comma");

require('bootstrap');
require('bootstrap/dist/css/bootstrap.css');
//require('bootstrap/dist/css/bootstrap-theme.css');

require("font-awesome/package.json");
require('style-loader!css-loader!less-loader!../css/font-awesome.less');

//require('detect-browser');
window.browser1=require('detect-browser');

//const { detect } = require('detect-browser');
//const browser = detect();



//require('../css/common.scss');
require('../css/common.css');
//require('../css/enroll.scss');
//require('../css/access.scss');
require('../css/responsive.css');
//require('../css/page-simple.scss');
//require('../css/mentoring-form.scss');
//require('../css/gameplan.css');
//require('../css/page-bundle.scss');
//require('../css/join11.css');
//require('../css/special.css');


window.Cookies = require('js-cookie');


window.isMobile = require('./mobile-test').isMobile;

require('./video-scroller');
//require('./smooth-scrolling');

window.exitpopup = require('./exitpopup.js');
require('../css/exitpopup.css');

var Clever = {};

//Clever.enrollPage = require('./page-enroll');
//Clever.gameplanPage = require('./page-gameplan');
Clever.securePage = require('./page-secure');

window.Clever = Clever;




